import React from 'react';
import { FieldArray, change } from 'redux-form';
import LensForm from './LensForm'
import { connect } from 'react-redux';
import ImportWrapper from '../../../../../components/authorised/order/edit/import/ImportWrapper';
class RenderLens extends React.Component {

  handleAddNew() {
    const { fields, pprops, formValues } = this.props
    if (fields.length === 0) {
      fields.push({ ...formValues.finalized_lenses_attributes, id: null })
    }
    else {
      fields.push({ ...formValues.finalized_lenses_attributes[fields.length - 1], id: null })
    }
    setTimeout(() => pprops.submit(), 500)
  }

  render() {
    const { template, isTemplate, fields, pprops, formName, prescription, prescriptionModule } = this.props
    return (
      <span>
        <div className='d-flex align-items-center justify-content-end'>
          {!isTemplate && (fields.length === 0) &&
            <button type="button" className="btn btn-primary float-right mt-5" onClick={() => this.handleAddNew()}>
              <i className='la la-plus mr-2 font-size-16'></i>
              Add New
            </button>
          }
          {prescriptionModule && <div className='ml-4'>
            <ImportWrapper order={{ patient_id: prescription.patient_attributes?.id }} importName="contact_lens" prescription={prescription} prescriptionModule={prescriptionModule} importNameTitle="Previous Contact Lens Prescriptions" addBtnLabel="Add Previous Prescriptions" />
          </div>}
        </div>
        {fields.map((member, index) => {
          const lensFromForm = pprops.formValues?.finalized_lenses_attributes?.[index];
          const lensFromExam = pprops.lensesAttributes?.[index];
          const currentContactLens = lensFromForm || lensFromExam || { ...pprops.lensesAttributes[pprops.lensesAttributes.length - 1], id: null };

          return (
          <div className="card-body" key={currentContactLens?.id || index}>
            <div className="row my-5">
              <div className="col">
                <span className="badge badge-dark">Contact Lens Rx {index + 1}</span>
              </div>
            </div>
            <LensForm
              {...this.props}
              currentContactLens={currentContactLens}
              name={`finalized_lenses_attributes[${index}]`}
              baseName={`finalize_prescription[contact_lens][contact_lenses][0]`}
              fieldValues={template.finalize_prescription.contact_lens.contact_lenses[0]}
              formName={formName}
              key={`${currentContactLens?.od_contact_lens_id || ''}-${currentContactLens?.os_contact_lens_id || ''}-${index}`}
            />
            <div className='mt-3'>
              <div>
                {!isTemplate && (fields.length === index + 1) &&
                  <button type="button" className="btn btn-primary float-right" onClick={() => this.handleAddNew()}>
                    <i className='la la-plus mr-2 font-size-16'></i>
                    Add New
                  </button>
                }
                {!isTemplate &&
                  <button type="button" className="btn btn-outline-danger mr-7 float-right" aria-label="Close" onClick={() => { pprops.dispatch(change(formName, `${member}[_destroy]`, true)); setTimeout(() => pprops.submit(), 500) }}>
                    Remove Prescription
                  </button>
                }
              </div>
            </div>
          </div>
          );
        })}
      </span>
    );
  }
}

const ContactLensPrescription = props => {
  const { template, isTemplate, pprops, showPrescriptionModal, prescriptionData, examFinalizePrescriptionData, prescription, prescriptionModule } = props
  const name = isTemplate ? "finalize_prescription[contact_lens][contact_lenses]" : "finalized_lenses_attributes"
  return (
    <FieldArray name={name}
      props={{
        template: template,
        isTemplate: isTemplate,
        pprops: pprops,
        prescription,
        prescriptionModule,
        formValues: (showPrescriptionModal || prescription?.id) ? prescriptionData : examFinalizePrescriptionData,
        formName: (showPrescriptionModal || prescription?.id) ? 'PrescriptionForm' : 'examFinalizePrescriptionForm',
      }}
      component={RenderLens} />
  );
}

const mapStateToProps = (state) => {
  const { reports: { editing }, form: { PrescriptionForm, examFinalizePrescriptionForm } } = state;

  return {
    showPrescriptionModal: editing?.showPrescriptionModal,
    prescriptionData: PrescriptionForm?.values || {},
    examFinalizePrescriptionData: examFinalizePrescriptionForm?.values || {},
  }
}

export default connect(mapStateToProps)(ContactLensPrescription);